import * as React from 'react';
import { useReducer } from 'react';

interface ExtractQuestionsState {
  includeExplanation: boolean;
  fileKey: string | null;
  fileMetadata: {
    type: string | null;
    size: number | null;
  } | null;
}

type ExtractQuestionsAction =
  | {
      type: 'setIncludeExplanation';
      payload: { newIncludeExplanation: boolean };
    }
  | { type: 'reset' }
  | {
      type: 'addFileKey';
      payload: { newFileKey: string; fileType: string; fileSize: number };
    }
  | { type: 'removeFileKey' };

function initialState() {
  return { includeExplanation: true, fileKey: null, fileMetadata: null };
}

function reducer(
  state: ExtractQuestionsState,
  action: ExtractQuestionsAction
): ExtractQuestionsState {
  switch (action.type) {
    case 'setIncludeExplanation': {
      const { newIncludeExplanation } = action.payload;
      return { ...state, includeExplanation: newIncludeExplanation };
    }
    case 'addFileKey': {
      const { newFileKey, fileType, fileSize } = action.payload;
      return {
        ...state,
        fileKey: newFileKey,
        fileMetadata: { type: fileType, size: fileSize },
      };
    }
    case 'removeFileKey': {
      return { ...state, fileKey: null, fileMetadata: null };
    }
    case 'reset': {
      return initialState();
    }
    default: {
      const _exhaustiveCheck: never = action;
      if (__DEV__) {
        console.error('Unhandled action type:', _exhaustiveCheck);
      }
      return state;
    }
  }
}

export type DispatchExtractQuestionsAction =
  React.Dispatch<ExtractQuestionsAction>;

export function useExtractQuestionsReducer(): {
  state: ExtractQuestionsState;
  dispatch: DispatchExtractQuestionsAction;
} {
  const [state, dispatch] = useReducer(reducer, initialState());
  return { state, dispatch };
}
